import React from 'react';
import LightBox from '../Common/LightBox';
import $ from 'jquery';
import { prettyAlert } from '../Common/Dialog';

export default class NovoPontoRetanguloBase extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			textoBotao: '',
			textoLabel: '',
			is_lightbox_open: false,
			lightboxLocation: {
				left: 0,
				right: 0,
				top: 0,
				botom: 0,
				height: 0,
				width: 0
			}
		};

		window.addEventListener('resize', this.handleResize.bind(this));
		window.addEventListener('scroll', this.handleResize.bind(this));
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize.bind(this));
		window.removeEventListener('scroll', this.handleResize.bind(this));
	}

	handleResize() {
		let elements = document.getElementsByClassName('panel-map-options');
		if (elements.length > 0) {
			const location = document.getElementsByClassName('panel-map-options')[0].getBoundingClientRect();
			this.setState({
				lightboxLocation: location
			});
		} 
	}

	getStyle() {
		return {
			overlay: { backgroundColor: 'transparent' },
			content: {
				position: 'relative',
				left: this.state.lightboxLocation.left,
				top: this.state.lightboxLocation.top,
				right: this.state.lightboxLocation.right,
				bottom: this.state.lightboxLocation.bottom,
				height: this.state.lightboxLocation.height,
				width: this.state.lightboxLocation.width - 15,
				overflowY: "auto",
				overflowX: "hidden"
			}
		};
	}

	conteudoLightbox() {
		return (
			<div></div>
		);
	}

	validate() {
		const inputsFound = $('.lightbox-novo-ponto-retangulo .form-group');

		for (const fg of inputsFound) {
			const label = fg.children[0].innerHTML;

			if (label.startsWith('Lat') || label.startsWith('Long')) {
				const inputValue = fg.children[1].value;

				if (!inputValue) {
					const message = `O campo ${label} é obrigatório.`;

					prettyAlert(message);

					return false;
				}
			}

		}

		return true;
	}

	render () {
		return (
			<div>
				<button
					type="button"
					className="btn btn-primary btn-block"
					onClick={(evt) => { 
						this.novo();
					}}>
					{this.state.textoBotao}
				</button>
				
				<LightBox
					style={this.getStyle()}
					isOpen={this.state.is_lightbox_open}
					onClose={() => this.setState({is_lightbox_open: false})}>
					<div className='lightbox-novo-ponto-retangulo'>
						<label className='titulo center'>{this.state.textoLabel}</label>
						{this.conteudoLightbox()}
						<div style={{marginTop: '20px'}}></div>
						<button
							type="button"
							className="btn btn-primary btn-block"
							onClick={(evt) => {
								if (!this.validate()) return;
								this.setState({is_lightbox_open: false}); 
								this.finalizar();
							}}>
							Finalizar
						</button>
						<button
							type="button"
							className="btn btn-error btn-block"
							onClick={(evt) => {  
								this.cancelar();
							}}>
							Cancelar
						</button>
					</div>
				</LightBox>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Documents/NovoPontoRetanguloBase.js